export const isPrerender = !!navigator.userAgent.match(/bot|prerender|headless/gi);
